import { tss } from "tss-react/mui";

export const useContactSectionStyles = tss.withName("ContactSection").create(({ theme }) => ({
    layout: {
        display: "grid",
        gridTemplateColumns: "1fr 1.2fr",
        gap: theme.spacing(8),
        alignItems: "start",
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
            gap: theme.spacing(4),
        },
    },
    overline: {
        marginBottom: theme.spacing(1.5),
    },
    title: {
        marginBottom: theme.spacing(2),
    },
    description: {
        color: theme.palette.text.secondary,
        lineHeight: 1.8,
        marginBottom: theme.spacing(4),
    },
    contactInfo: {
        display: "flex",
        flexDirection: "column" as const,
        gap: theme.spacing(2.5),
    },
    contactItem: {
        display: "flex",
        gap: theme.spacing(2),
        alignItems: "center",
    },
    contactIcon: {
        width: 44,
        height: 44,
        borderRadius: 2,
        backgroundColor: theme.palette.primary[50],
        border: `1px solid ${theme.palette.primary[200]}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme.palette.primary.main,
        flexShrink: 0,
    },
    contactLabel: {
        fontSize: "0.75rem",
        color: theme.palette.text.secondary,
        fontWeight: 600,
        textTransform: "uppercase" as const,
        letterSpacing: "0.06em",
    },
    contactValue: {
        fontWeight: 600,
        color: theme.palette.text.primary,
        textDecoration: "none",
        "&:hover": {
            color: theme.palette.primary.main,
        },
    },
}));
